<template>
  <section>
    <div
      v-if="isVisible"
      ref="milesNBonusRibbonMockBackground"
      class="s-milesNBonus-ribbon__mock-background"></div>
  </section>
  <section
    v-if="isVisible"
    ref="milesNBonusRibbon"
    class="s-milesNBonus-ribbon">
    <div class="page-container">
      <div
        class="s-milesNBonus-ribbon__body"
        :class="{ 'logged-in': milesNBonusLoggedIn }">
        <div
          v-if="!milesNBonusLoggedIn"
          class="s-milesNBonus-ribbon__main"
          @click="showModal">
          <div class="new d-none d-lg-block">
            {{ dictionary.milesNBonusTagLabel }}
          </div>
          <span v-html="ribbonText"></span>
        </div>
        <button
          v-if="!milesNBonusLoggedIn"
          type="button"
          class="btn-close"
          aria-label="Close"
          @click="onClickClose">
          <i class="icon-close-light"></i>
        </button>

        <div v-if="milesNBonusLoggedIn" class="s-milesNBonus-ribbon__left">
          <LazyImage v-if="milesNBonusLogo" :image="milesNBonusLogo" />
          <span>
            {{ dictionary.milesNBonusIDPrefix }}
          </span>
          <span class="bold">
            {{ id }}
          </span>
        </div>
        <div
          v-if="milesNBonusLoggedIn"
          class="s-milesNBonus-ribbon__right d-none d-lg-block">
          <span class="bold">
            {{ ribbonLoggedText }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue'
import * as lib from './../../lib/lib'
import LazyImage from './common/LazyImage.vue'
import MBRibbon from '../../modules/MBRibbon'

const milesNBonusRibbon = ref(null)
const milesNBonusRibbonMockBackground = ref(null)

const isVisible = ref(true)
const { dictionary, configuration, milesNBonusLogo, milesNBonusAccount } =
  lib.getData('milesNBonusData')
const { milesNBonusLoggedIn } = configuration
const id = milesNBonusAccount?.id
const onClickClose = () => {
  isVisible.value = false
}

const props = defineProps({
  step: { required: false, type: String, default: '' },
})
const ribbonText = ref('')
const ribbonLoggedText = ref('')

const showModal = () => {
  document.dispatchEvent(new CustomEvent('showMilesNBonusModal', {}))
}

const runAfterDOMUpdate = async () => {
  await nextTick()
  dictionariesBasedOnStep()
  new MBRibbon(milesNBonusRibbon.value, milesNBonusRibbonMockBackground.value)
}

const dictionariesBasedOnStep = () => {
  switch (props.step) {
    case '1':
      ribbonText.value = dictionary.milesNBonusStep1RibbonText
      ribbonLoggedText.value = dictionary.milesNBonusStep1LoggedRibbonLoggedText
      break
    case '2':
      ribbonText.value = dictionary.milesNBonusStep2RibbonText
      ribbonLoggedText.value = dictionary.milesNBonusStep2LoggedRibbonLoggedText
      break
    case '3':
      ribbonText.value = dictionary.milesNBonusStep2RibbonText
      ribbonLoggedText.value = dictionary.milesNBonusStep2LoggedRibbonLoggedText
      break
    default:
      ribbonText.value = dictionary.milesNBonusStep2RibbonText
      ribbonLoggedText.value = dictionary.milesNBonusStep2LoggedRibbonLoggedText
      break
  }
}

onMounted(() => {
  runAfterDOMUpdate()
})
</script>
